import { render } from "./Index.vue?vue&type=template&id=71599c13&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=71599c13&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71599c13"]])

export default __exports__